// システムコード
export const systemCd = 1;

//消費税区分
export const zeiKbn = {
  // 未登録
  mitouroku: "",
  // 外税/明細単位
  sotozeiMei: "0",
  // 外税/伝票単位
  sotozeiDen: "1",
  // 外税/請求単位
  sotozeiSeikyu: "2",
  // 内税/明細単位
  uchizeiMei: "3",
  // 非課税
  hikazei: "4",
};

//上代表示区分
export const jodaihyojiKbn = {
  tsujyo: 0,
  uchizei: 1,
};

//消費税丸め区分
export const zeimarumeKbn = {
  // 四捨五入
  shishagonyu: 0,
  // 切り捨て
  kirisute: 1,
  // 切り上げ
  kiriage: 2,
};

// 編集区分
export const editKbn = {
  // 登録
  register: "0",

  // 編集
  update: "1",

  // 参照
  reference: "2",
};

// 受注ステータス
export const juchuStatus = {
  // 受注登録済
  juchuRegistered: 0,

  // 受注確定済
  juchuFixed: 1,

  // 出荷予定作成済
  shukayoteiSakuseizumi: 2,

  // 出荷確定済
  shukaFixed: 3,

  // キャンセル済
  cancelFixed: 9,
};

// 倉庫種別区分
export const sokoshubetsuKbn = {
  physicalSoko: 0,
  logicalSoko: 1,
  hikiateSoko: 2,
  zairyoSoko: 3,
  henpinSoko: 4,
  othersSoko: 5,
};

// ロケーション管理区分
export const locationkanriKbn = {
  notManagement: 0,
  management: 1,
};

// 納入先諸口区分
export const shokuchiKbn = {
  normal: 0,
  shokuchi: 1,
};

// 単価丸め区分
export const tankamarumeKbn = {
  // 四捨五入
  round: 0,

  // 切り捨て
  floor: 1,

  // 切り上げ
  ceil: 2,
};

// 金額丸め区分
export const kinmarumeKbn = {
  // 四捨五入
  round: 0,

  // 切り捨て
  floor: 1,

  // 切り上げ
  ceil: 2,
};

// 出荷状況
export const shukajokyo = {
  mishori: "0",
  shijizumi: "1",
  kakuteizumi: "2",
  cancel: "9",
};

// 作業指示書発行状況
export const sagyohako = {
  mihako: "0",
  hakozumi: "1",
};

// 受注区分
export const juchuKbn = {
  // 通常受注
  normal: "0",
  // 見込品生産
  expected: "1",
};

// 手入力受注区分
export const tenyuryokujuchuKbn = {
  // なし
  none: 0,
  // あり
  exists: 1,
};

// 手入力上代区分
export const tenyuryokujodaiKbn = {
  // なし
  none: 0,
  // あり
  exists: 1,
};

// 予約区分
export const yoyakuKbn = {
  // なし
  none: "0",
  // あり
  exists: "1",
};

// セット商品区分
export const setshohinKbn = {
  // 単品
  single: 0,

  // セット品
  set: 1,
};

// 出荷状況 B080060
export const B080060shukajokyo = {
  // 未処理
  mishori: 0,
  // 指示済
  shijizumi: 1,
  // 確定済
  kakuteizumi: 2,
};

// 出荷状況 B080070で使用する
export const B080070shukajokyo = {
  // 未処理
  mishori: 0,
  // 指示済
  shijizumi: 1,
  // 確定済
  kakuteizumi: 2,
  // キャンセル
  cancel: 9,
};

// キャンセル区分
export const cancelKbn = {
  // 未
  mi: 0,
  // 済み
  sumi: 1,
  // 全て
  zen: 2,
};

// 数量訂正
export const suryoteisei = {
  // 訂正無
  none: 0,
  // 訂正有
  exists: 1,
};

// 出荷状況 B080030,B080040,B080050にてつかう
export const sutiShukajokyo = {
  // 未処理
  mishori: 0,
  // 指示済
  shijizumi: 1,
  // 確定済
  kakuteizumi: 2,
  // キャンセル
  cancel: 9,
};

// ピッキング発行
export const pickinghako = {
  // 未発行
  mihako: 0,
  // トータル発行済
  totalhakozumi: 1,
  // 店別発行済
  tenbetuhakozumi: 2,
};

// B090030 倉庫コード(物理倉庫)
export const sokoCd = {
  // 物理倉庫
  physicalsokoCd: "901",
};

// 名称マスタの名称区分(meisho_kbn = 9000)
export const meishoKbn = {
  // 単位
  unit: "1",
  // 備考
  biko: "2",
  // 配送方法
  haisoMethod: "5",
  // 明細備考
  meisaibiko: "7",
  // 取引先単価分類
  torihikisakiTankabunrui: "8",
  // 商品単価分類
  shohinTankabunrui: "9",
  // ルートコード
  routeCd: "10",
  // 得意先分類１
  tokuibun1: "11",
  // 得意先分類２
  tokuibun2: "12",
  // 得意先分類３
  tokuibun3: "13",
  // 得意先分類４
  tokuibun4: "14",
  // 得意先分類５
  tokuibun5: "15",
  // 商品分類１
  shohinbun1: "16",
  // 商品分類２
  shohinbun2: "17",
  // 商品分類３
  shohinbun3: "18",
  // 商品分類４
  shohinbun4: "19",
  // 商品分類５
  shohinbun5: "20",
  // 仕入先分類１
  shirebun1: "21",
  // 仕入先分類２
  shirebun2: "22",
  // 仕入先分類３
  shirebun3: "23",
  // 仕入先分類４
  shirebun4: "24",
  // 仕入先分類５
  shirebun5: "25",
  // ライン
  line: "31",
  // 運送会社
  unsogaisha: "32",
  // 伝票種別
  denpyoshubetsu: "33",
  // 添付伝票
  tenpudenpyo: "34",
  // 発送先
  hasosaki: "35",
  // 発送区分
  hasoKbn: "36",
  // 作家名
  sakaNm: "37",
  // 加工種別
  kakoshubetsu: "38",
  // WH単価
  whTanka: "39",
  // WH原単価
  whGentanka: "40",
  // 明細パターン
  meisaipattern: "41",
  // 帳簿分類コード１
  chobobunruiCd1: "50",
  // 帳簿分類コード２
  chobobunruiCd2: "51",
  // 帳簿分類コード３
  chobobunruiCd3: "52",
  // 帳簿分類コード４
  chobobunruiCd4: "53",
  // 帳簿分類コード５
  chobobunruiCd5: "54",
  // 帳簿分類コード６
  chobobunruiCd6: "55",
  // 帳簿分類コード７
  chobobunruiCd7: "56",
  // 帳簿分類コード８
  chobobunruiCd8: "57",
  // 帳簿分類コード９
  chobobunruiCd9: "58",
  // 帳簿分類コード１０
  chobobunruiCd10: "59",
  // 帳簿分類コード１１
  chobobunruiCd11: "60",
  // 帳簿分類コード１２
  chobobunruiCd12: "61",
  // 帳簿分類コード１３
  chobobunruiCd13: "62",
  // 帳簿分類コード１４
  chobobunruiCd14: "63",
  // 帳簿分類コード１５
  chobobunruiCd15: "64",
};

// 手入力売上区分
export const tenyuryokuuriKbn = {
  // なし
  none: 0,
  // あり
  exists: 1,
};

//受注ステータス
export const juchuHaneiKbn = {
  //ファイル取込済
  fileTorikomizumi: "0",
  //構成品不備
  koseihinfubi: "1",
  //受注反映済
  haneizumi: "2",
  //受注反映済(一部在庫不足)
  haneizumiZaikofusoku: "3",
};

// 単価区分
export const tankaKbn = {
  // 通常単価
  tujo: 0,

  // wh単価
  wh: 1,
};

//取込データ種別
export const torikomidetaKbn = {
  //東急ハンズEDI
  tokyuhandsEdi: "1",
  //ロフトEDI
  loftEdi: "2",
  //汎用フォーマット
  generic: "3",
};

// 諸口区分(商品)
export const shohinShokuchiKbn = {
  // 標準
  normal: 0,
  // 諸口
  shokuchi: 1,
};

// 商品種別区分
export const shohinshubetsuKbn = {
  // 通常商品
  regularProduct: 1,
  // 見込み生産
  makeToStockProduct: 3,
  // 受注生産
  madeToOrder: 4,
  // カレンダー
  calender: 5,
  // クリスマスカード
  christmasCard: 6,
  // クリスマス雑貨
  christmasMiscellaneousGoods: 7,
  // 限定品
  limitedEdition: 8,
  // 材料品
  materials: 9,
};

// 完了区分
export const kanryoKbn = {
  // 未完了
  incomplete: 0,
  // 完了
  completed: 1,
};

// 売上作成区分
export const uriagesakuseiKbn = {
  // 受注確定
  juchuKakutei: 0,
  // 新規作成
  new: 1,
};

// 売上入金区分
export const urinyukinKbn = {
  // 売上
  uriage: "0",
  // 入金
  nyukin: "1",
};

// 消化区分
export const shokaKbn = {
  // 通常
  normal: "0",
  // 消化
  shoka: "1",
};

// 受注生産品の有無区分
export const juchuSeisanhinKbn = {
  // なし
  nashi: "0",
  // あり
  ari: "1",
};

// 請求対象
export const seikyujokenKbn = {
  // あり
  shitei: "0",
  // なし
  zenken: "9",
};

// 伝票種別コード
export const denpyoshubetsuCdValue = {
  // APJ伝票
  apjDenpyo: "005",
  // CS1型伝票
  cs1Denpyo: "008",
  // CS2型伝票
  cs2Denpyo: "012",
  // CSタイプ用伝票
  cstypeDenpyo: "007",
  // 家具統一伝票
  kaguDenpyo: "006",
  // 百貨店統一伝票
  hyakatenDenpyo: "013",
  // 真美堂伝票
  sinbido2Denpyo: "016",
  // サンリオ伝票
  sanrioDenpyo: "019",
  // 手書き伝票
  tegakiDenpyo: "000",
};

// 手入力区分
export const tenyuryokuKbn = {
  // なし
  none: 0,
  // あり
  exists: 1,
};

// 営業所コード
export const apjEigyoCd = {
  // APJ
  apj: "1",
  // APJ 工房
  apjKobo: "2",
};

// 内訳区分(発注入力で使用)
export const hachuUchiwakeKbn = {
  // 通常
  tujo: "0",
  // 値引
  nebiki: "2",
  // 見本
  mihon: "3",
  // 諸経費
  shokeihi: "4",
  // 送料
  soryo: "5",
};

// 得意先照会ダイアログ呼出しパラメータ
export const calledParam = {
  // 得意先照会
  tokui: "0",
  // 請求先照会
  seikyu: "1",
  // 売掛先照会
  urikake: "2",
  // 全件
  zenken: "3",
};

// 請求締処理区分
export const seikyushimeshoriKbn = {
  // 通常
  tujo: 0,
  // キャンセル
  cancel: 1,
};

// 請求締状況ステータス
export const seikyushimeStatus = {
  // 正常終了
  seijo: 1,
  // 処理中
  shorityu: 2,
  // エラー終了
  error: 3,
};

// B030070 グリッドデータの売上/入金判別用区分
export const uriageNyukinCheckKbn = {
  // 売上
  uriage: "掛売",
  // 入金
  nyukin: "入金",
};

// 発注 イベント利用権限定義マスタ.営業所権限
export const eigyoKengen = {
  // 所属営業所のみ指定可
  only: "0",
  // 全営業所指定可権限
  all: "1",
};

// B070020 ロケ選択
export const locasentaku = {
  // しない
  off: "0",
  // する
  on: "1",
};

// B070020 入荷選択
export const nyukasentaku = {
  // しない
  off: "0",
  // する
  on: "1",
};

// B070020 入庫選択
export const nyukosentaku = {
  // しない
  off: "0",
  // する
  on: "1",
};

// B070020 レコード区分
export const recordKbn = {
  // 入荷予定ファイルベース
  nyukayotei: 0,
  // 仕入明細ファイルベース
  shiremei: 1,
};

// 在庫管理区分
export const zaikokanriKbn = {
  // しない
  off: "0",
  // する
  on: "1",
};

// 在庫引当区分
export const zaikohikiateKbn = {
  // しない
  off: "0",
  // する
  on: "1",
};

// 請求先区分
export const seikyuKbn = {
  // ならない
  NARANAI: 0,
  // なる
  naru: 1,
};

// 売掛先区分
export const urikakeKbn = {
  // ならない
  NARANAI: 0,
  // なる
  naru: 1,
};

// 標準区分
export const hyojunnonyuKbn = {
  // 非標準
  notHyojun: "0",
  // 標準
  hyojun: "1",
};

// モード
export const mode = {
  // 新規
  shinki: "0",
  // 修正
  shusei: "1",
  // 削除
  sakujo: "2",
};

// 請求書記載区分
export const seikyushokisaKbn = {
  // しない
  shinai: 0,

  // する
  suru: 1,
};

// 採番種別
export const saibanshubetsu = {
  // APJ
  apj: "0",
  // APJ 工房
  apjKobo: "1",
  // インストア
  instore: "2",
};

// 伝票種別区分
export const denpyoshubetcuKbn = {
  // 受注
  juchu: 1,
  // 出荷
  shuka: 2,
  // 売上
  uriage: 3,
  // 発注
  hachu: 4,
  // 入荷
  nyuka: 5,
  // 仕入
  shiire: 6,
  // 移動
  ido: 7,
  // 入金
  nyukin: 8,
  // 出金
  shukin: 9,
  // 在庫調整
  zaikoChosei: 10,
  // 棚卸
  tanaoroshi: 11,
  // セット
  set: 14,
  // 製造実績
  seizoZiseki: 22,
};

// 内訳区分(仕入入力で使用)
export const shireUchiwakeKbn = {
  // 通常
  tujo: "0",
  // 値引
  nebiki: "2",
  // 見本
  mihon: "3",
  // 諸経費
  shokeihi: "4",
  // 送料
  soryo: "5",
  // 通常返
  tujoHen: "10",
  // 値引返
  nebikiHen: "12",
  // 見本返
  mihonHen: "13",
  // 諸費返
  shokeihiHen: "14",
  // 送料返
  soryoHen: "15",
};
